import { render, staticRenderFns } from "./kyc.vue?vue&type=template&id=1504ab68&scoped=true"
import script from "./kyc.vue?vue&type=script&lang=js"
export * from "./kyc.vue?vue&type=script&lang=js"
import style0 from "./kyc.vue?vue&type=style&index=0&id=1504ab68&prod&scoped=true&lang=css"
import style1 from "./kyc.vue?vue&type=style&index=1&id=1504ab68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1504ab68",
  null
  
)

export default component.exports